import React from 'react'
import styled from 'react-emotion'

import Section from '../components/section/Section'
import Person from '../components/person'

import hova from '../assets/team-hova.png'
import jro from '../assets/team-jro.png'
import kriggen from '../assets/team-kriggen.png'
import brandon from '../assets/team-brandon.png'
import madison from '../assets/team-madison.png'
import brandie from '../assets/team-brandie.png'
import natassia from '../assets/team-natassia.png'
import debut from '../assets/whistle-debut.jpeg'
import whistleGame from '../assets/whistle-game.jpg'
import whistleBooth from '../assets/whistle-booth.jpg'
import whistleShare from '../assets/whistle-share.jpg'
import whistleBadge from '../assets/whistle-top-rated-x2.png'
import whistleRated from '../assets/2019-whistle-share.jpg'

const Page = styled.div``

const Header = styled.h1`
  padding-top: 2rem;
  text-align: center;
`

const SubHeader = styled.h2`
  text-align: center;
  font-size: 2rem;
`

const List = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const ImageList = styled.div`
  -webkit-column-count: 1;
  -moz-column-count:1;
  column-count: 1;
  -webkit-column-gap: 1em;
  -moz-column-gap: 1em;
  column-gap: 1em;
  margin: 1.5em;
  padding: 0;
  -moz-column-gap: 1.5em;
  -webkit-column-gap: 1.5em;
  column-gap: 1.5em;
  overflow:visible;
  @media (min-width: 800px) {
    -webkit-column-count: 2;
    -moz-column-count:2;
    column-count: 2;
  }
  @media (min-width: 1025px) {
    -webkit-column-count: 3;
    -moz-column-count:3;
    column-count: 3;
  }
  img {
    width: 100%;
  }
`

const Text = styled.p`
  padding: 1rem 0;
  text-align: center;
`

const Image = styled.img`
  margin: 0 auto;
  display: block;
  width: 100%;
  max-width: 600px;
`

const team = [{
  name: "Christopher Hovanessian",
  title: "Cofounder/CEO",
  url: "https://www.linkedin.com/in/christopherhovanessian/",
  image: hova
}, {
  name: "Jonathan Rojas",
  title: "Cofounder/President",
  url: "https://www.linkedin.com/in/jonathanrojas0226/",
  image: jro
}, {
  name: "Kevin Riggen",
  title: "CTO",
  url: "https://www.linkedin.com/in/kevinriggen/",
  image: kriggen
}, {
  name: "Brandon Dougherty",
  title: "Sr. Software Engineer",
  url: "https://www.linkedin.com/in/brandon-dougherty/",
  image: brandon
}, {
  name: "Madison Van Alst",
  title: "Customer Success Manager",
  url: "https://www.linkedin.com/in/madison-van-alst-6a7b3582/",
  image: madison
}, {
  name: "Brandie Jackson",
  title: "VP Sales",
  url: "https://www.linkedin.com/in/brandie-jackson-43079695/",
  image: brandie
}, {
  name: "Natassia Cruz",
  title: "Implementations",
  url: "https://www.linkedin.com/in/natassia-cruz-9b03301b2/",
  image: natassia
}]

const Schedule = (props) => {

  return (
    <Page>
      <Header>About Us</Header>
      <Section>
        <p>At Whistle, we believe there is a better way to run your hotel. A more efficient, less invasive way where guests are engaged from booking through departure. We're passionate about what we do, and our mission is to help hotels achieve it. We focus on bridging the gap between your guests and your team, simplifying the experience for everyone involved. Through our software, Whistle’s goal is to become the digital front desk for your hotel, reducing the workload of your staff while elevating the guest experience.</p>
      </Section>
      <Section>
        <SubHeader>Meet the team!</SubHeader>
        <List>
          {team.map((person, idx) => <Person key={idx} person={person} />)}
        </List>
      </Section>
      <Section>
        <Image src={debut} />
        <Text>Whistle debuted its solution at HFTP HITEC 2015, during their first-ever E20X competition, winning the grand prize! Since then, the team has continuously focused on providing award-winning solutions to the hotel industry.</Text>
        <ImageList>
          <Image src={whistleGame} />
          <Image src={whistleShare} />
          <Image src={whistleBooth} />
        </ImageList>
        <Text>Here is some of the Whistle team at HITEC 2019 in Minneapolis, MN. Time flies!</Text>
        <Image src={whistleBadge} />
        <Image src={whistleRated} />
        <Text>Whistle has the honor of being crowned the ‘Top-Rated Guest Messaging Platform’, two consecutive years in a row (2018 & 2019), in HotelTechReport’s HotelTechAwards. With 62%+ more votes than 2nd place, the team’s customer-centric approach is key to their success!
        </Text>
      </Section>
    </Page>
  )
}
 
export default Schedule;


// WEBPACK FOOTER //
// ./src/pages/about.js